import styled, { css } from 'styled-components';
import { Colors } from '../../constants/Colors';

export const StyledWallet = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  flex-direction: column;
  padding: 25px;
  background-color: ${Colors.background};
`;

export const StyledWalletTable = styled.div`
  padding: 15px;
  margin-top: 20px;
  width: 100%;
`;

export const StyledWalletButtons = styled.div`
  align-self: center;
  width: 98%;
`;
